import React, { useEffect, useRef, useState } from 'react';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

export default function LinkActionsMenu({ styles, onCopy, onEdit, onClose, disableCopy = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onDocClick(e) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    }
    function onEsc(e) {
      if (e.key === 'Escape') setOpen(false);
    }

    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

  return (
    <div ref={ref} style={styles.kebabWrap}>
      <button
        type="button"
        style={styles.kebabBtn}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((p) => !p);
        }}
        aria-label="Ações"
        title="Ações"
      >
        <MoreVertOutlinedIcon style={{ fontSize: 18, color: '#6B7280' }} />
      </button>

      {open && (
        <div style={styles.kebabMenu} role="menu" onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            style={{
              ...styles.kebabItem,
              ...(disableCopy ? { opacity: 0.45, cursor: 'not-allowed' } : null),
            }}
            disabled={disableCopy}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (disableCopy) return;
              if (onCopy) onCopy();
              setOpen(false);
            }}
            title={disableCopy ? 'Checklist encerrado' : 'Copiar Link'}
          >
            <ContentCopyOutlinedIcon style={styles.kebabIcon} />
            Copiar Link
          </button>

          <button
            type="button"
            style={styles.kebabItem}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (onEdit) onEdit();
              setOpen(false);
            }}
          >
            <SettingsOutlinedIcon style={styles.kebabIcon} />
            Editar Configurações
          </button>

          <div style={styles.kebabDivider} />

          <button
            type="button"
            style={styles.kebabItemDanger}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (onClose) onClose();
              setOpen(false);
            }}
          >
            <HighlightOffOutlinedIcon style={styles.kebabIconDanger} />
            Encerrar Checklist
          </button>
        </div>
      )}
    </div>
  );
}